import { DataTable } from '@nimbus-ds/patterns';
import { LocationResponseDto } from '@tiendanube/common';
import { SortableDataList } from 'commons/components';
import LocationItem from '../LocationItem';

interface LocationsSortableListProps {
  locationsList: LocationResponseDto[];
  handleOnChange: (newOrder: LocationResponseDto[]) => void;
  showDetails?: boolean;
  isLoading?: boolean;
}

function LocationsSortableList({
  locationsList,
  handleOnChange,
  showDetails = true,
  isLoading = false,
}: Readonly<LocationsSortableListProps>): JSX.Element {
  return (
    <DataTable header>
      <SortableDataList<LocationResponseDto>
        items={locationsList}
        onChange={handleOnChange}
        showFooter={isLoading}
        renderItem={(location) => (
          <LocationItem
            location={location}
            isDragging
            showDetails={showDetails}
          />
        )}
      />
    </DataTable>
  );
}

export default LocationsSortableList;
